import { __rest } from "tslib";
import React from 'react';
import { BodyText } from '../Type';
import { AlertWarning } from '../Alert';
import { useFormState } from 'react-final-form';
import { useFieldRegistry } from './FieldRegistry';
import { FORM_ERROR } from 'final-form';
import { getDeepKeys } from '../../utils';
import { node } from 'prop-types';
export default function FormErrorsAlert({ fieldErrorMessage }) {
    const { getFieldLabel } = useFieldRegistry();
    const { errors, submitErrors, hasValidationErrors, hasSubmitErrors } = useFormState({
        subscription: {
            errors: true,
            submitErrors: true,
            hasValidationErrors: true,
            hasSubmitErrors: true,
        },
    });
    if (hasValidationErrors || hasSubmitErrors) {
        const actualErrors = hasValidationErrors ? errors : submitErrors;
        const _a = actualErrors, _b = FORM_ERROR, formError = _a[_b], fieldErrors = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);
        const hasFieldErrors = Object.keys(fieldErrors).length > 0;
        return (React.createElement(AlertWarning, null,
            formError && React.createElement(BodyText, { noTopSpacer: true }, formError),
            hasFieldErrors && (React.createElement(React.Fragment, null,
                React.createElement(BodyText, { noTopSpacer: !formError }, fieldErrorMessage),
                React.createElement("ul", null, getDeepKeys(fieldErrors, true, true).map((fieldName) => (React.createElement("li", { key: fieldName }, getFieldLabel(fieldName)))))))));
    }
    return null;
}
FormErrorsAlert.propTypes = {
    fieldErrorMessage: node,
};
//# sourceMappingURL=FormErrorsAlert.js.map